module.exports = __webpack_public_path__ + "static/img/logo106.4c300c8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo106.png
// module id = UK+r
// module chunks = 1